import useApiQuery from 'shared/hooks/use-api-query';
import billingsKeys from '../util/billings-keys';
import {OccurrenceProps} from 'modules/orders/types';

const useBillingOccurrences = (billingId: string) => {
  return useApiQuery<OccurrenceProps[]>({
    url: `/billing/${billingId}/occurrences`,
    queryKey: billingsKeys.occurrences(billingId),
  });
};

export default useBillingOccurrences;
